/**
 * The route that answers anything the route tree does not name.
 *
 * Author: Mahmoud Ragab Ahmed.
 *
 * An unknown path is answered the same way the API answers an unknown or withheld
 * record: with the absence panel, which says what happened and what to do next, and
 * never pretends to know whether the record exists.
 */

import { Link } from "react-router";

import { strings } from "../brand/strings";
import { NotFoundPanel } from "./parts";

export function NotFoundPage(): React.JSX.Element {
  return (
    <>
      <h2 className="q-shell__heading">{strings.common.absenceHeading}</h2>
      <NotFoundPanel />
      <p className="q-row q-gap-top">
        <Link className="q-link" to="/">
          {strings.common.backToDashboard}
        </Link>
      </p>
    </>
  );
}
